import React, { useState, useEffect } from 'react';
import './App.css';

const bgImages = [
  'ogle-logo-bg-01.png',
  'ogle-logo-bg-02.png',
  'ogle-logo-bg-03.png',
  'ogle-logo-bg-04.png',
  'ogle-logo-bg-05.png',
  'ogle-logo-bg-06.png',
  'ogle-logo-bg-07.png',
  'ogle-logo-bg-08.png',
  'ogle-logo-bg-09.png',
];

function useIsMobile() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return isMobile;
}

const APPLICATIONS_CLOSE_AT = new Date('2026-08-13T23:59:00+03:00');

function App() {
  const [bgIndex, setBgIndex] = useState(() => Math.floor(Math.random() * bgImages.length));
  const isMobile = useIsMobile();
  const showApplyButton = new Date() < APPLICATIONS_CLOSE_AT;

  const handleLogoClick = () => {
    setBgIndex((prev) => (prev + 1) % bgImages.length);
  };

  const handleTextHover = () => {
    setBgIndex((prev) => (prev + 1) % bgImages.length);
  };

  return (
    <div className="white-bg-root">
      <div
        className="logo-bg-centered"
        onClick={handleLogoClick}
      >
        <img
          src={`${process.env.PUBLIC_URL}/${bgImages[bgIndex]}`}
          alt="Logo background"
          className="logo-bg-img"
        />
        <h1 
          className="main-text logo-text"
          onMouseEnter={handleTextHover}
        >
          OGLE
        </h1>
      </div>
      {!isMobile && <br/>}
      {showApplyButton && (
        <div className="apply-cta">
          <img
            src={process.env.PUBLIC_URL + '/uznemsana.png'}
            alt=""
            className="apply-illustration"
          />
          <a
            href="https://forms.gle/My24C1schWCZUmCv6"
            target="_blank"
            rel="noopener noreferrer"
            className="apply-button"
          >
            Uzņemšanas anketa
          </a>
        </div>
      )}
      <p className="tagline"><b>Koris OGLE</b> – draugu un domubiedru kopums, kas kvēlo par kopīgu sapni un ļauj tam skanēt mūzikā.</p>
      <div className="socials-bar">
        <a
          href="https://www.instagram.com/korisogle/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Instagram"
          className="social-icon-link"
        >
          <img src={process.env.PUBLIC_URL + '/logo-1.png'} alt="Instagram logo" className="social-img-icon" />
        </a>
        <a
          href="https://www.facebook.com/korisOgle"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Facebook"
          className="social-icon-link"
        >
          <img src={process.env.PUBLIC_URL + '/logo-2.png'} alt="Facebook logo" className="social-img-icon" />
        </a>
      </div>
    </div>
  );
}

export default App; 